import React from 'react';
import { Box, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import routes from 'constants/routes';
import { BranchCashSummary } from 'features/branchCash/components/BranchCashSummary';
import { TEAM_CASH_BRANCH } from 'features/branchCash/constants';

interface BranchCashBoxProps {
	/** Nombre canónico del equipo (ej. "CENTRO UY"). */
	team: string;
}

/**
 * Resumen de la caja de la sucursal del equipo para el dashboard de equipo.
 * Muestra el bloque de recibos sin depositar + acceso rápido a hacer depósito.
 */
export function BranchCashBox({ team }: BranchCashBoxProps): JSX.Element | null {
	const branch = TEAM_CASH_BRANCH[team];

	if (!branch) return null;

	return (
		<Box mb={3}>
			<BranchCashSummary branch={branch} title="Caja de sucursal" detailTo={routes.branchCash.detail(branch)} />
			<Box display="flex" justifyContent="flex-end" mt={1}>
				<Button
					size="small"
					variant="contained"
					color="primary"
					startIcon={<AccountBalanceIcon sx={{ fontSize: 15 }} />}
					component={RouterLink}
					to={routes.branchCash.deposit(branch)}
					sx={{ textTransform: 'none' }}
				>
					Hacer depósito
				</Button>
			</Box>
		</Box>
	);
}
